import { IAudioPlayerTrack } from "@agp/shared.user-app/module/guide-player.module/audio-client";
import ServiceLocator from "../../../../domain/service-locator";
import MonotoneAudioPlayer from "../components/monotone-audio-player";

export const MonotoneAudioPlayerContainer = () => {
  const guidePlayerModule = ServiceLocator.GuidePlayerModule;

  // GuidePlayerModuleから必要なデータを取得
  const currentTrack = guidePlayerModule.currentTrack.watch();
  const isPlaying = guidePlayerModule.isPlaying.watch();
  const currentSeek = guidePlayerModule.currentSeek.watch();
  const canNext = guidePlayerModule.canNext.watch();
  const canPrev = guidePlayerModule.canPrev.watch();

  // 現在のトラックのdurationを取得
  const getDuration = (): number => {
    if (!currentTrack) return 0;

    // IAudioPlayerTrackの場合はdurationプロパティを使用
    if ("duration" in currentTrack) {
      return (currentTrack as IAudioPlayerTrack).duration;
    }

    // IAudioSpeechTrackの場合はtextの長さを使用（文字数）
    return currentTrack.text.length;
  };

  // コールバック関数
  const handlePlayPause = () => {
    guidePlayerModule.playOrPause();
  };

  const handleSeek = (time: number) => {
    guidePlayerModule.seek(time);
  };

  const handleNext = () => {
    if (canNext) {
      guidePlayerModule.next();
    }
  };

  const handlePrev = () => {
    if (canPrev) {
      guidePlayerModule.prev();
    }
  };

  const handleClose = () => {
    // プレイヤーを停止してトラックをクリア
    guidePlayerModule.stop();
  };

  return (
    <MonotoneAudioPlayer
      track={currentTrack}
      isPlaying={isPlaying}
      currentTime={currentSeek}
      duration={getDuration()}
      onPlayPause={handlePlayPause}
      onSeek={handleSeek}
      onNext={canNext ? handleNext : undefined}
      onPrev={canPrev ? handlePrev : undefined}
      onClose={handleClose}
    />
  );
};
